export class Agreement {
  constructor() {
    this.termsContent = document.querySelector('.terms-content')
    this.agreeCheckbox = document.getElementById('agree-checkbox')
    this.submitButton = document.getElementById('submit-btn')
    this.pageType = this.getPageType()
    this.init()
  }

  init() {
    if (this.termsContent) this.addScrollListener()
    if (this.agreeCheckbox) this.addCheckboxListener()
    if (this.submitButton) this.addSubmitButtonListener()
  }

  getPageType() {
    const pathname = window.location.pathname
    if (pathname.includes('agreement-new')) {
      return 'new'
    } else if (pathname.includes('agreement-mid')) {
      return 'mid'
    }
    return 'default'
  }
  addScrollListener() {
    let hasScrolledToEnd = false

    const checkIfScrollable = () => {
      const scrollHeight = this.termsContent.scrollHeight
      const clientHeight = this.termsContent.clientHeight
      return scrollHeight > clientHeight
    }

    // 初期状態で無効にする（念のため）
    if (this.agreeCheckbox) {
      this.agreeCheckbox.disabled = true
    }

    // スクロールイベント設定
    this.termsContent.addEventListener('scroll', () => {
      if (hasScrolledToEnd) return

      const scrollTop = this.termsContent.scrollTop
      const scrollHeight = this.termsContent.scrollHeight
      const clientHeight = this.termsContent.clientHeight

      const isScrolledToEnd = scrollHeight - scrollTop <= clientHeight + 1

      if (isScrolledToEnd && this.agreeCheckbox) {
        this.agreeCheckbox.disabled = false
        hasScrolledToEnd = true
      }
    })

    // 初期状態でスクロール不要なら即有効化しない（必ずスクロールが必要）
    if (!checkIfScrollable()) {
      console.warn('スクロールする量が不足しています。プラポリの高さを見直してください。')
    }
  }

  addCheckboxListener() {
    this.agreeCheckbox.addEventListener('change', () => {
      if (this.submitButton) {
        this.submitButton.disabled = !this.agreeCheckbox.checked
      }
    })
  }

  addSubmitButtonListener() {
    this.submitButton.addEventListener('click', () => {
      if (this.pageType === 'new') {
        window.location.href = '/recruit/entry-new'
      } else if (this.pageType === 'mid') {
        window.location.href = '/recruit/entry-mid'
      } else {
        window.location.href = '/recruit/entry-form'
      }
    })
  }
}
